import { type AlgoliaRecord } from '../../algolia/model/AlgoliaRecord'
import { useGetExperiment } from '../hooks'
import { EXPERIMENT_NAME_DISCOUNT_REMOVAL_FR } from '../model/EXPERIMENT_NAME'
import { EXPERIMENT_VARIATION } from '../model/EXPERIMENT_VARIATION'

export const EXCLUDED_DISCOUNTED_PRODUCTS_CUSTOM_CODE = 'cro_4200'

const removeDiscountIfNeeded = ({
  prices,
}: {
  prices: AlgoliaRecord['prices']
}): AlgoliaRecord['prices'] => {
  if (!prices) {
    return prices
  }
  const listPrice = prices.listPrice?.amount
  const retailPrice = prices.retailPrice.amount
  // use the retail price as list price
  if (listPrice && retailPrice && retailPrice > 0 && listPrice > retailPrice) {
    return {
      ...prices,
    }
  }
  if (listPrice) {
    return {
      ...prices,
      listPrice: undefined,
    }
  }

  return prices
}

export const useGetAlgoliaProductWithoutDiscountDiscountExperiment = ({
  hit,
}: {
  hit: AlgoliaRecord
}): AlgoliaRecord => {
  const discountExperiment = useGetExperiment(
    EXPERIMENT_NAME_DISCOUNT_REMOVAL_FR,
  )

  // if experiment is not enabled, or category code is whitelisted, or variant is not V1
  // return hit with no changes
  if (
    !discountExperiment.isEnabled ||
    discountExperiment.variant !== EXPERIMENT_VARIATION.V1 ||
    hit.custom_usecases?.includes(EXCLUDED_DISCOUNTED_PRODUCTS_CUSTOM_CODE)
  ) {
    return hit
  }

  const prices = removeDiscountIfNeeded({ prices: hit.prices })

  return {
    ...hit,
    best_offer: hit.best_offer
      ? {
          ...hit.best_offer,
          discount: 0,
          strike_price: undefined,
        }
      : undefined,
    discountInPercent: 0,
    listPrice: hit.price,
    listPriceFormatted: '',

    prices,
    variants: hit.variants?.map((variant) => {
      return {
        ...variant,
        best_offer: {
          ...variant.best_offer,
          discount: 0,
          strike_price: undefined,
        },
        discount: 0,
        hide_discounts: true,
      }
    }),
  }
}
